<template>
  <div class="home">
    <NewAccountDetailPage />
  </div>
</template>

<script>
import NewAccountDetailPage from '../components/elements/pages/NewAccountDetailPage.vue'
export default {
  name: 'NewEditAccountDetails',
  metaInfo: {
    title: 'Edit My Account Detail'
  },
  components: {
    NewAccountDetailPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
